import { DynamicFieldData } from '../../../types/dynamic-control-types';

export const createUserField: DynamicFieldData[] = [
    {
        fieldName: 'name',
        inputType: 'text',
        label: 'User Name',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'email',
        inputType: 'text',
        label: 'Email',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'password',
        inputType: 'password',
        label: 'Password',
        defaultValue: '123456',
        className: 'col-span-1',
    },
    {
        fieldName: 'phone_number',
        inputType: 'text',
        label: 'Mobile',
        defaultValue: '',
        className: 'col-span-1',
    },
    {
        fieldName: 'role_id',
        inputType: 'auto-complete',
        label: 'Role Name',
        defaultValue: '',
        className: 'col-span-1',
        actionBtn: true,
        actionBtnLabel: 'Add Role',
    },
];

export const createUsersPermissionField: DynamicFieldData[] = [
    {
        fieldName: 'roleName',
        inputType: 'text',
        label: 'Role Name',
        defaultValue: '',
        className: 'col-span-1',
        actionBtn: true,
        actionBtnLabel: 'Add Role',
    },
    {
        fieldName: 'resourceName',
        inputType: 'text',
        label: 'Resource Name',
        defaultValue: '',
        className: 'col-span-1',
    },
];
